import { render, staticRenderFns } from "./FooterCom.vue?vue&type=template&id=936b0eb8"
import script from "./FooterCom.vue?vue&type=script&lang=js"
export * from "./FooterCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports